export const locale = {
  lang: 'pt',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: 'Dashboards',
        BADGE: '2',
        ANALYTICS: 'Analytics',
        ECOMMERCE: 'comércio eletrônico',
        USER: 'User'
      },
      APPS: {
        SECTION: 'Aplicativos e páginas',
        EMAIL: 'O email',
        CHAT: 'Bate-papo',
        TODO: 'Façam',
        CALENDAR: 'Calendário',
        INVOICE: {
          COLLAPSIBLE: 'Fatura',
          LIST: 'Lista',
          PREVIEW: 'Antevisão',
          EDIT: 'Editar',
          ADD: 'Adicionar'
        },
        ECOMMERCE: {
          COLLAPSIBLE: 'comércio eletrônico',
          SHOP: 'Comprar',
          DETAIL: 'Detalhes',
          WISHLIST: 'Lista de Desejos',
          CHECKOUT: 'Confira'
        },
        USER: {
          COLLAPSIBLE: 'Do utilizador',
          LIST: 'Lista',
          VIEW: 'Visualizar',
          EDIT: 'Editar'
        }
      },
      PAGES: {
        SECTION: 'Páginas',
        AUTH: {
          COLLAPSIBLE: 'Autenticação',
          LOGIN1: 'Login V1',
          LOGIN2: 'Login V2',
          REGISTER1: 'Registrar V1',
          REGISTER2: 'Registrar V2',
          FORGOTPASSWORD1: 'Esqueci a senha V1',
          FORGOTPASSWORD2: 'Esqueci a senha V2',
          RESETPASSWORD1: 'Redefinir senha V1',
          RESETPASSWORD2: 'Redefinir senha V2'
        },
        ACCOUNTSETTINGS: 'Configurações de Conta',
        PROFILE: 'Perfil',
        FAQ: 'Perguntas frequentes',
        KB: 'Base de Conhecimento',
        PRICING: 'Preços',
        BLOG: {
          COLLAPSIBLE: 'Blog',
          LIST: 'Lista',
          DETAILS: 'Detalhes',
          EDIT: 'Editar'
        },
        MAIL: {
          COLLAPSIBLE: 'Modelo de Correio',
          WELCOME: 'Receber',
          RESET: 'Redefinir senha',
          VERIFY: 'Verificar',
          DEACTIVATE: 'Desativar',
          INVOICE: 'Fatura',
          PROMOTIONAL: 'Promocional'
        },
        MISC: {
          COLLAPSIBLE: 'Diversos',
          COMINGSOON: 'Em breve',
          NOTAUTH: 'Não autorizado',
          MAINTENANCE: 'Manutenção',
          ERROR: 'Erro'
        }
      },
      UI: {
        SECTION: 'Interface de usuário',
        TYPOGRAPHY: 'Tipografia',
        COLORS: 'Cores',
        FEATHER: 'Pena',
        CARDS: {
          COLLAPSIBLE: 'Cartas',
          BADGE: 'Novo',
          BASIC: 'Básico',
          ADVANCE: 'Avançar',
          STATISTICS: 'Estatisticas',
          ANALYTICS: 'Analytics',
          ACTIONS: 'Ações'
        },
        COMPONENTS: {
          COLLAPSIBLE: 'Componentes',
          ALERTS: 'Alertas',
          AVATAR: 'Avatar',
          BADGES: 'Distintivos',
          BREADCRUMBS: 'Migalhas de pão',
          BUTTONS: 'Botões',
          CAROUSEL: 'Carrossel',
          COLLAPSE: 'Colapso',
          DIVIDER: 'Divisor',
          DROPDOWNS: 'Dropdowns',
          GROUP: 'Grupo de Lista',
          OBJECTS: 'Objetos de mídia',
          MODALS: 'Modais',
          COMPONENT: 'Navs',
          PAGINATION: 'Paginação',
          PBADGES: 'Emblemas de comprimidos',
          PILLS: 'Pílulas',
          POPOVERS: 'Popovers',
          PROGRESS: 'Progresso',
          RATINGS: 'Avaliações',
          SPINNER: 'Spinner',
          TABS: 'Abas',
          TIMELINE: 'Linha do tempo',
          TOASTS: 'Torradas',
          TOOLTIPS: 'Dicas de ferramentas'
        },
        EX: {
          COLLAPSIBLE: 'Extensão',
          SWEET_ALERTS: 'Sweet Alerts',
          BLOCKUI: 'BlockUI',
          TOASTER: 'Toastr',
          SLIDER: 'Slider',
          DRAGDROP: 'Arraste e solte',
          TOUR: 'Percorrer',
          CLIPBOARD: 'Prancheta',
          MEDIAPLAYER: 'Reprodutor de mídia',
          CONTEXTMENU: 'Menu contextual',
          SWIPER: 'Swiper',
          TREEVIEW: 'Tree View',
          I18N: 'I18n'
        },
        LAYOUTS: {
          COLLAPSIBLE: 'Layouts de página',
          COLLAPSED_MENU: 'Menu recolhido',
          BOXED_LAYOUT: 'Layout em caixa',
          WITHOUT_MENU: 'Sem Menu',
          LAYOUT_EMPTY: 'Layout Vazio',
          LAYOUT_BLANK: 'Layout em branco'
        }
      },
      FT: {
        SECTION: 'Formulários e tabelas',
        ELEMENT: {
          COLLAPSIBLE: 'Elementos de Formulário',
          INPUT: 'Entrada',
          INPUTGROUPS: 'Grupos de entrada',
          INPUTMASK: 'Máscara de entrada',
          TEXTAREA: 'Textarea',
          CHECKBOX: 'Caixa de seleção',
          RADIO: 'Rádio',
          SWITCH: 'Interruptor',
          SELECT: 'Selecione',
          NUMBERINPUT: 'Número de entrada',
          FILEUPLOADER: 'Uploader de arquivos',
          QUILLEDITOR: 'Editor de pena',
          FLATPICKER: 'Flatpicker',
          DATETIMEPICKER: 'Selecionador de data e hora'
        },
        LAYOUTS: 'Layouts de formulário',
        WIZARD: 'Assistente de Formulários',
        VALIDATION: 'Validações de formulário',
        REPEATER: 'Repetidor de Formulário',
        TABLE: 'Mesa',
        DATATABLES: 'DataTables'
      },
      CM: {
        SECTION: 'Cartas e mapas',
        CHARTS: {
          COLLAPSIBLE: 'Gráficos',
          BADGE: '2',
          APEX: 'Ápice',
          CHARTJS: 'ChartJS'
        },
        MAPS: 'Google Maps'
      },
      OTHERS: {
        SECTION: 'Outros',
        LEVELS: {
          COLLAPSIBLE: 'Níveis de Menu',
          SECOND: 'Segundo nível',
          SECOND1: {
            COLLAPSIBLE: 'Segundo nível',
            THIRD: 'Terceiro nivel',
            THIRD1: 'Terceiro nivel'
          }
        },
        DISABLED: 'Menu Desabilitado',
        DOCUMENTATION: 'Documentação',
        SUPPORT: 'Levante o Suporte'
      }
    }
  }
};
